import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AttachmentCountModal = ({
  maxFileLimit,
  closeModal,
  attachmentsCount,
  fileUploadsInProgCount
}) => {
  const remainingCount = maxFileLimit - attachmentsCount - fileUploadsInProgCount;
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: closeModal
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("h2", {
        className: "is--heading-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.title",
          options: {
            maxFileLimit
          }
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.body",
          options: {
            remainingCount
          }
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: closeModal,
        className: "m-x-auto",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.capability-editor.attachment-count-modal.okay"
        })
      })
    })]
  });
};
AttachmentCountModal.displayName = 'AttachmentCountModal';
AttachmentCountModal.propTypes = {
  attachmentsCount: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
  fileUploadsInProgCount: PropTypes.number,
  maxFileLimit: PropTypes.number
};
export default AttachmentCountModal;